module.exports = __webpack_public_path__ + "img/img-pickup04.b935631e.jpg";